import { APICallV3Post } from 'reactApp/api/APICall';

export enum BillingStartEvent {
    mailSpaceTariffs = 'mail_space_visit',
}

export class EventStartAPICall extends APICallV3Post {
    _method = 'billing/event/start';
}
